module.exports = __webpack_public_path__ + "img/logo-lira.ca725090.png";